import { EmploymentOccupation } from "../../lead-api";
import { type OccupationMenuItem } from "../Employment.types";

const items: EmploymentOccupation[] = [
  EmploymentOccupation.Salaried,
  EmploymentOccupation.SelfEmployed,
  EmploymentOccupation.Student,
  EmploymentOccupation.Unemployed,
];

export const indiaOccupationItems: OccupationMenuItem[] = items.map((it) => {
  return {
    label: "inputs.employment." + it.toLowerCase(),
    value: it,
  };
});
